<div class="leaderboard-home flex flex-col min-h-0 w-full bg-[var(--consumer-canvas-bg)]">
  <app-sub-header
    variant="leaderboard"
    [badgeText]="subHeaderBadgeText"
    [title]="subHeaderTitle"
    [description]="subHeaderDescription"
    [iconSrc]="subHeaderIconSrc"
  ></app-sub-header>

  <div
    class="leaderboard-home__content w-full max-w-[var(--container-max-width)] mx-auto pb-10 flex flex-col gap-8 min-w-0 box-border"
  >
    <div class="flex justify-center w-full">
      <div class="leaderboard-home__tabs-row">
        <div class="leaderboard-home__tabs" role="tablist" aria-label="Leaderboard category">
          @for (tab of categoryTabs; track tab.key) {
            <button
              type="button"
              role="tab"
              class="leaderboard-home__tab"
              [class.leaderboard-home__tab--active]="activeCategory() === tab.key"
              [attr.aria-selected]="activeCategory() === tab.key"
              (click)="changeCategory(tab.key)"
            >
              <img
                [src]="tabIcon(tab)"
                alt=""
                width="18"
                height="18"
                [ngClass]="tabIconClass(tab)"
              />
              {{ tab.label }}
            </button>
          }
        </div>
      </div>
    </div>

    @if (isLoading()) {
      <p class="text-center text-[var(--text-muted-on-light)] m-0 py-6">Loading leaderboard…</p>
    } @else {
      @if (activeCategory() === 'providers') {
        <app-leaderboard-provider
          [leadershipMembers]="leadershipMembers()"
          [providersPagination]="providersPagination()"
          [showLoadMore]="showLoadMoreProviders()"
          (loadMore)="loadMoreProviders()"
        ></app-leaderboard-provider>
      }

      @if (activeCategory() === 'assets') {
        <app-leaderboard-assets
          [leadershipMembers]="leadershipMembers()"
          [assetsPagination]="assetsPagination()"
          [showLoadMore]="showLoadMoreAssets()"
          (loadMore)="loadMoreAssets()"
        ></app-leaderboard-assets>
      }

      @if (activeCategory() === 'organisation') {
        <app-leaderboard-organisation
          [leadershipMembers]="leadershipMembers()"
          [organisationPagination]="organisationPagination()"
          [showLoadMore]="showLoadMoreOrganisation()"
          (loadMore)="loadMoreOrganisations()"
        ></app-leaderboard-organisation>
      }
    }
  </div>
</div>
<app-footer></app-footer>
